// extracted by mini-css-extract-plugin
export var boxItems = "_6f-1";
export var boxItemsLg = "_6f-2";
export var button = "_6f-7";
export var buttonLg = "_6f-8";
export var filterGroupBox = "_6f-0";
export var icon = "_6f-3";
export var iconSecondary = "_6f-6";
export var iconWrapper = "_6f-4";
export var iconWrapperLg = "_6f-5";